import { cx } from '@emotion/css';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { useCallback, useState } from 'react';

import { buttonClassName } from 'apps/dashboard/shared/scripts/components/Cta/styles';
import {
  CardFilter,
  Status,
} from 'apps/shared/scripts/__generated__/graphql.generated';
import { Button, Dropdown, DropdownItem } from 'apps/shared/scripts/components';

import { filterOptions } from './constants';
import { activeButtonClassName, menuClassName } from './styles';
import { getFilterLabel } from './utils';

interface Props {
  filter: CardFilter;
  onFilter: (filter: CardFilter) => Promise<void>;
}

const FilterCards = ({ filter, onFilter }: Props) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  const onToggle = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen]);

  const handleFilter = useCallback(
    (status: Status | null) => {
      if (!status) {
        onFilter({});
      } else {
        onFilter({ ...filter, status });
      }
      onToggle();
    },
    [filter, onFilter, onToggle],
  );

  return (
    <Dropdown
      button={
        <Button
          className={cx(buttonClassName, { [activeButtonClassName]: isOpen })}
          faIcon={isOpen ? faCaretUp : faCaretDown}
          subtle
        >
          {getFilterLabel(filter)}
        </Button>
      }
      menuClassName={menuClassName}
      isOpen={isOpen}
      setOpen={setOpen}
    >
      {filterOptions.map(({ label, status }) => {
        const isActive =
          filter.status === status || (!filter.status && status === null);
        return (
          <DropdownItem
            key={label}
            active={isActive}
            onClick={() => handleFilter(status)}
          >
            {label}
          </DropdownItem>
        );
      })}
    </Dropdown>
  );
};

FilterCards.displayName = 'FilterCards';

export default FilterCards;
